(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oc-moroccan-craft-stories"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      const track = root.querySelector('[data-track]');
      const slides = Array.from(root.querySelectorAll('[data-slide]'));
      const dots = Array.from(root.querySelectorAll('[data-dot]'));
      if (!track || slides.length === 0) return;
      let active = 0;
      let frame = 0;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const centerSlide = (index, behavior) => {
        const slide = slides[index];
        if (!slide) return;
        track.scrollTo({ left: slide.offsetLeft + slide.offsetWidth / 2 - track.clientWidth / 2, behavior: reducedMotion ? 'auto' : behavior });
      };
      const applyActive = (index) => {
        active = index;
        slides.forEach((slide, i) => slide.classList.toggle('is-active', i === active));
        dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === active);
          if (i === active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };
      const updateActive = () => {
        const center = track.getBoundingClientRect().left + track.clientWidth / 2;
        let nearest = 0;
        let distance = Infinity;
        slides.forEach((slide, i) => {
          const box = slide.getBoundingClientRect();
          const current = Math.abs(box.left + box.width / 2 - center);
          if (current < distance) { nearest = i; distance = current; }
        });
        applyActive(nearest);
      };
      const goTo = (index) => {
        const next = (index + slides.length) % slides.length;
        applyActive(next);
        centerSlide(next, 'smooth');
      };
      root.querySelector('[data-previous]')?.addEventListener('click', () => goTo(active - 1));
      root.querySelector('[data-next]')?.addEventListener('click', () => goTo(active + 1));
      dots.forEach((dot) => dot.addEventListener('click', () => goTo(Number(dot.dataset.dot))));
      track.addEventListener('scroll', () => {
        window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(updateActive);
      }, { passive: true });
      slides.forEach((slide) => {
        const video = slide.querySelector('video');
        const button = slide.querySelector('[data-video-toggle]');
        if (!video || !button) return;
        const sync = () => {
          const playing = !video.paused && !video.ended;
          slide.classList.toggle('is-playing', playing);
          button.setAttribute('aria-label', playing ? button.dataset.pauseLabel : button.dataset.playLabel);
        };
        button.addEventListener('click', () => {
          if (video.paused || video.ended) {
            slides.forEach((other) => { const otherVideo = other.querySelector('video'); if (otherVideo && otherVideo !== video) otherVideo.pause(); });
            video.play().catch(() => {});
          } else video.pause();
        });
        video.addEventListener('play', sync);
        video.addEventListener('pause', sync);
        video.addEventListener('ended', sync);
      });
      requestAnimationFrame(() => { const initial = Math.floor(slides.length / 2); centerSlide(initial, 'auto'); applyActive(initial); });
    };
    document.querySelectorAll('[data-oc-craft-stories]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-oc-craft-stories]').forEach(init));
  })();

  } catch(e) { console.error(e); }
})();
})();
